/* tslint:disable:quotemark */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JtsnxAlertService } from './jtsnx-alert.service';
import { AlertModel } from './alert.model';
import { DatePipe } from '@angular/common';
import { from } from 'rxjs';

@Component({
  selector: 'lib-jtsnx-alert',
  templateUrl: './jtsnx-alert.component.html',
  styleUrls: ['./jtsnx-alert.component.css'],
})
export class JtsnxAlertComponent implements OnInit {
  @Input() alertInputData;
  @Output() openCWClicked = new EventEmitter();
  @Output() openAlertEditClicked = new EventEmitter();
  @Output() closeWindowClicked = new EventEmitter();

  juvenileStateInfo: any = {};
  rolePermission: any = {};

  booAllowBHPR = false;
  booAllowMHDiagnostics = false;
  booJuvAtYDC = false;

  alertList: any = [];
  csecList: any = [];
  alertsInfo: any = [];
  alertModel: AlertModel = new AlertModel();

  AlertBeginDate: Date = null;
  currentDate = null;
  AlertEndDate: Date = null;
  caseWorkerName = '';
  chkReferral = false;
  chkSuicidePrevention = false;
  chkBehaviorProblems = false;
  chkVictimizationRisk = false;
  CSECBeginDate: Date = null;
  CSECEndDate: Date = null;
  PCEndDate: Date = null;
  PCStartDate: Date = null;
  headerInfo: any = {};
  constructor(public jtsnxAlertService: JtsnxAlertService, private datePipe: DatePipe) {}

  ngOnInit(): void {
    console.log(this.alertInputData);
    this.juvenileStateInfo = this.alertInputData.juvenileStateInfo;
    this.rolePermission = this.alertInputData.rolePermission;
    this.jtsnxAlertService.serverUrl = this.alertInputData.serverUrl;
    this.headerInfo = this.alertInputData.headerInfo;
    console.log(this.alertModel);
    if (this.juvenileStateInfo.juvenileID !== undefined) {
      this.initAlert();
    } else {
    }
  }

  initAlert() {
    this.AlertBeginDate = new Date();
    this.currentDate = new Date();
    this.alertModel = new AlertModel();
    this.booJuvAtYDC = this.headerInfo.juvPlaSite > 1000 && this.headerInfo.juvPlaSite < 2000;
    this.booAllowBHPR = this.rolePermission.programmers || this.rolePermission.bhprFullRights;
    if ([24, 4, 1006].includes(this.juvenileStateInfo.sitlocationCode)) {
      this.booAllowMHDiagnostics = [24, 4, 1006].includes(this.headerInfo.juvPlaSite);
    } else {
      this.booAllowMHDiagnostics = false;
    }

    this.getAlertList();
    this.getAlertCaseWorker();
    this.getAlerts();
  }

  private getAlertList() {
    this.jtsnxAlertService.getAlertList().subscribe((response: any) => {
      this.alertList = response;
      if (this.rolePermission.mentalHealthFullRights === false && this.rolePermission.programmers === false) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 21);
      }
      if (this.booAllowBHPR === false && this.rolePermission.programmers === false) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 19);
      }
      if (
        this.juvenileStateInfo.sitlocationCode !== this.headerInfo.juvPlaSite ||
        !(this.juvenileStateInfo.sitModOp === 'R' || this.juvenileStateInfo.sitModOp === 'Y' || this.rolePermission.programmers === true)
      ) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 15);
      }
      if (
        this.rolePermission.mentalHealthFullRights === false &&
        this.rolePermission.officeOfClassification === false &&
        this.rolePermission.programmers === false
      ) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 22 && a.luAlertID !== 70);
      }
      if (
        ((this.juvenileStateInfo.sitlocationCode !== this.headerInfo.juvPlaSite || this.juvenileStateInfo.sitModOp !== 'R') &&
          this.juvenileStateInfo.sitModOp !== 'Y') ||
        (this.rolePermission.mentalHealthFullRights === false &&
          this.rolePermission.officeOfClassification === false &&
          this.rolePermission.programmers === false)
      ) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 10);
      }
      if (
        (!(this.juvenileStateInfo.sitModOp === 'R' || this.juvenileStateInfo.sitModOp === 'Y') || this.headerInfo.juvPlaSite >= 2000) &&
        this.headerInfo.juvPlaSite !== '' &&
        this.headerInfo.juvPlaSite !== null
      ) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 40 && a.luAlertID !== 50);
      }
      if (
        this.juvenileStateInfo.sitlocationCode !== this.headerInfo.juvPlaSite ||
        !(this.juvenileStateInfo.sitModOp === 'R' || this.juvenileStateInfo.sitModOp === 'Y')
      ) {
        this.alertList = this.alertList.filter((a) => a.luAlertID !== 112 && a.luAlertID !== 113 && a.luAlertID !== 114);
      }
      console.log(this.alertList);
    });
  }

  private getAlerts() {
    this.jtsnxAlertService.getAlertsInfo(this.juvenileStateInfo.juvenileID).subscribe((response: any) => {
      this.alertsInfo = response;
    });
  }

  private getAlertCaseWorker() {
    this.jtsnxAlertService.getAdmitCaseWorker(this.juvenileStateInfo.juvenileID).subscribe((response: any) => {
      this.alertModel.InsertAlertMainInput.AlertContactID = response.casCaseWorkerID;
      this.caseWorkerName = response.caseWName === null || response.caseWName === '' ? 'Not Assigned' : response.caseWName;
    });
  }

  alertFormSubmitted(alertForm) {
    if (alertForm.valid) {
      this.alertModel.InsertAlertMainInput.JuvenileID = this.juvenileStateInfo.juvenileID;
      this.alertModel.InsertAlertMainInput.UserId = this.juvenileStateInfo.userID;
      this.alertModel.InsertAlertMainInput.JuvID = this.juvenileStateInfo.juvID;
      this.alertModel.InsertAlertMainInput.AlertBeginDate = this.datePipe.transform(this.AlertBeginDate, 'yyyy-MM-ddTHH:mm:ss');
      this.alertModel.InsertAlertMainInput.AlertEndDate = this.datePipe.transform(this.AlertEndDate, 'yyyy-MM-ddTHH:mm:ss');
      this.alertModel.InsertAlertCSECInput.CSECBeginDate = this.datePipe.transform(this.CSECBeginDate, 'yyyy-MM-ddT00:00:00');
      this.alertModel.InsertAlertCSECInput.CSECEndDate = this.datePipe.transform(this.CSECEndDate, 'yyyy-MM-ddT00:00:00');
      this.alertModel.InsertAlertPCInput.PCStartDate = this.datePipe.transform(this.PCStartDate, 'yyyy-MM-ddTHH:mm:ss');
      this.alertModel.InsertAlertPCInput.PCEndDate = this.datePipe.transform(this.PCEndDate, 'yyyy-MM-ddTHH:mm:ss');
      let ableToSave = true;
      let matchedAlertName = '';
      for (const item of this.alertsInfo) {
        if (
          item.activeStatus === 1 &&
          item.alertID === +this.alertModel.InsertAlertMainInput.AlertId &&
          +this.alertModel.InsertAlertMainInput.AlertId !== 95
        ) {
          ableToSave = false;
          matchedAlertName = item.luAlertDescription;
          alert("This Juvenile already has an open '" + matchedAlertName + "' Alert.");
        } else if (item.activeStatus === 1 && item.alertID === 40 && +this.alertModel.InsertAlertMainInput.AlertId === 50) {
          ableToSave = false;
          alert('The information has not been saved. \nThe youth is currently on a Level 2 Alert. The Level 2 Alert must be closed before a Level 3 Alert can begin.')
        } else if (item.activeStatus === 1 && item.alertID === 50 && +this.alertModel.InsertAlertMainInput.AlertId === 40) {
          ableToSave = false;
          alert('The information has not been saved. \nThe youth is currently on a Level 3 Alert. The Level 3 Alert must be closed before a Level 2 Alert can begin. \nOnly Licensed Staff or a QMHP who has consulted Licensed Staff may end a Level 3 Alert.');
        }
      }
      console.log(ableToSave);
      if (ableToSave === true) {
        this.jtsnxAlertService.insertAlert(this.alertModel).subscribe(() => {
          alertForm.submitted = false;
          alert('Alert has been saved successfully');
          setTimeout(() => {
            this.initAlert();
          }, 10);
        });
      }
      console.log(this.alertModel);
    } else {
      alert('Please fill all the required fields');
    }
  }

  setAlertEndDateToNow() {
    this.AlertEndDate = new Date();
  }

  openCW(action) {
    const emitModel = {
      action,
      cwID: this.alertModel.InsertAlertMainInput.AlertContactID,
      from: 'alert',
    };
    this.openCWClicked.emit(emitModel);
  }

  setCW(id, name) {
    this.alertModel.InsertAlertMainInput.AlertContactID = id;
    this.caseWorkerName = name;
  }

  checkboxChecked(num, chk) {
    switch (num) {
      case 0:
        this.alertModel.InsertAlertChecksInput.chkReferral = chk === true ? 1 : 0;
        break;
      case 1:
        this.alertModel.InsertAlertChecksInput.chkSuicidePrevention = chk === true ? 1 : 0;
        break;
      case 2:
        this.alertModel.InsertAlertChecksInput.chkBehaviorProblems = chk === true ? 1 : 0;
        break;
      case 3:
        this.alertModel.InsertAlertChecksInput.chkVictimizationRisk = chk === true ? 1 : 0;
        break;
    }
  }

  alertIDChanged() {
    const copyOfMain = this.alertModel.InsertAlertMainInput;
    this.alertModel = new AlertModel();
    this.alertModel.InsertAlertMainInput = copyOfMain;
    if (this.alertModel.InsertAlertMainInput.AlertId === '110') {
      this.jtsnxAlertService.getCSECLevelStatus(this.juvenileStateInfo.juvenileID).subscribe((response: any) => {
        this.csecList = response.csecLevelStatusAlertsResults;
      });
    }
  }

  openCSECIntro() {
    window.open(this.alertInputData.serverUrl + 'cdn/html/AlertCSECDefinitions.html', '_blank', 'width=400,height=400');
  }

  csecBeginDateMin(AlertBeginDate) {
    return new Date(this.datePipe.transform(AlertBeginDate, 'yyyy-MM-ddT00:00:00'));
  }

  openAlertAudit(id) {
    window.open(this.alertInputData.serverUrl + 'Alerts/AlertReports/rptauAlert.asp?AlertNum=' + id, '_blank', 'width=800,height=600');
  }

  openAlertEdit(alertNum, alertBeginDate) {
    const model = {
      alertNum,
      alertBeginDate,
    };
    this.openAlertEditClicked.emit(model);
  }

  closeWindow() {
    this.closeWindowClicked.emit();
  }
}
